import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {Owner} from "../../model/customer/owner";
import {CommonCrudService} from "../common/common-crud.service";
import {CrystalclearCustomerBackUrl} from "../config/crystalclear-customer-back-url";
import {VatRate} from "../../model/customer/vat-rate";

@Injectable({
  providedIn: 'root'
})
export class CustomerVatRateService extends CommonCrudService<VatRate> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearCustomerBackUrl.GET_CUSTOMER_VAT_RATE_LIST,
      CrystalclearCustomerBackUrl.SAVE_CUSTOMER_VAT_RATE,
      CrystalclearCustomerBackUrl.DELETE_CUSTOMER_VAT_RATE);
  }

}
